/**
 * نصوص «الخدمات المهنية» (/service-engagements): طلب تقييم أو استشارة أو تحليل
 * أو إدارة أملاك أو مرافق من مختص عقاري ومتابعته حتى التسليم. الزائر يرى معاينة
 * للخدمات ودعوة لتسجيل الدخول. تُستخدم عبر useTranslation('engage').
 *
 * أسماء الخدمات منقولة من المصطلحات القائمة (roleCatalog ودليل المختصين).
 */
const engage = {
  title: 'الخدمات المهنية',
  subtitle:
    'اطلب تقييماً عقارياً أو استشارة أو تحليلاً أو إدارة أملاك أو مرافق من مختص عقاري، وتابع طلبك حتى التسليم.',
  request: 'اطلب خدمة',
  cancel: 'إلغاء',

  types: {
    APPRAISAL: 'تقييم عقاري',
    CONSULTING: 'استشارات عقارية',
    ANALYSIS: 'تحليل عقاري',
    PROPERTY_MANAGEMENT: 'إدارة الأملاك',
    FACILITIES_MANAGEMENT: 'إدارة المرافق',
  },

  typeDescriptions: {
    APPRAISAL: 'تقدير قيمة عقارك من مقيّم عقاري.',
    CONSULTING: 'رأي مختص قبل أن تشتري أو تبيع أو تستثمر.',
    ANALYSIS: 'دراسة للسوق أو لعقار أو لمشروع بعينه.',
    PROPERTY_MANAGEMENT: 'تأجير عقارك ومتابعة مستأجريه.',
    FACILITIES_MANAGEMENT: 'صيانة المبنى وتشغيل مرافقه.',
  },

  statuses: {
    REQUESTED: 'تم الطلب',
    QUOTED: 'تم إرسال العرض',
    ACCEPTED: 'مقبول',
    IN_PROGRESS: 'قيد التنفيذ',
    DELIVERED: 'تم التسليم',
    COMPLETED: 'مكتمل',
    CANCELLED: 'ملغى',
  },

  advance: {
    QUOTED: 'تأكيد إرسال العرض',
    ACCEPTED: 'تأكيد القبول',
    IN_PROGRESS: 'بدء التنفيذ',
    DELIVERED: 'تسليم العمل',
    COMPLETED: 'إكمال الطلب',
  },

  guest: {
    title: 'سجّل الدخول لطلب خدمة مهنية',
    body: 'أرسل طلبك إلى مختص عقاري وتابعه من مكان واحد، من الطلب حتى التسليم.',
    servicesHeading: 'الخدمات المتاحة',
    howHeading: 'كيف تعمل',
    steps: {
      choose: 'اختر نوع الخدمة والمختص، واكتب ما تحتاجه.',
      review: 'يراجع المختص طلبك ويحدّث حالته: العرض، ثم القبول، ثم التنفيذ.',
      deliver: 'تابع الطلب هنا حتى التسليم، مع رابط ملف التسليم إن أرفقه المختص.',
    },
    signIn: 'سجّل الدخول',
    createAccount: 'أنشئ حساباً',
    browse: 'تصفّح المختصين',
  },

  tabs: {
    label: 'عرض الطلبات',
    mine: 'طلباتي',
    incoming: 'الطلبات الواردة',
    withCount: '{{label}} ({{n}})',
  },

  form: {
    heading: 'طلب خدمة جديد',
    type: 'نوع الخدمة',
    typePlaceholder: 'اختر نوع الخدمة',
    typeRequired: 'اختر نوع الخدمة.',
    title: 'عنوان الطلب',
    titlePlaceholder: 'مثال: تقييم شقة قبل بيعها',
    titleHint: 'عنوان قصير يصف طلبك، من 3 أحرف على الأقل.',
    titleTooShort: 'اكتب عنواناً من 3 أحرف على الأقل.',
    fee: 'الأتعاب المقترحة بالريال (اختياري)',
    feeHint: 'مبلغ بالأرقام دون كسور.',
    description: 'التفاصيل (اختياري)',
    descriptionPlaceholder: 'الموقع ونوع العقار والمطلوب بالتحديد.',
    submit: 'أرسل الطلب',
    sent: 'تم إرسال طلبك إلى المختص.',
  },

  provider: {
    label: 'المختص',
    placeholder: 'ابحث بالاسم أو المدينة',
    chooseTypeFirst: 'اختر نوع الخدمة أولاً',
    none: 'لا يوجد مختصون مسجّلون لهذه الخدمة بعد.',
    noMatch: 'لا يوجد مختص مطابق.',
    loadError: 'تعذّر تحميل قائمة المختصين، أدخل رقم نشاط المختص يدوياً.',
    unnamed: 'مختص عقاري',
    required: 'حدّد المختص.',
    manualToggle: 'لديك رقم نشاط المختص؟ أدخله يدوياً',
    directoryToggle: 'ابحث في قائمة المختصين',
    idLabel: 'رقم نشاط المختص',
    idHint: 'اطلبه من المختص الذي تتعامل معه.',
    idInvalid: 'رقم النشاط غير صحيح. تحقّق منه مع المختص.',
  },

  list: {
    loading: 'جارٍ تحميل الطلبات…',
    emptyMine: 'لم تطلب أي خدمة بعد.',
    emptyIncoming: 'لا توجد طلبات واردة على أنشطتك المهنية.',
  },

  card: {
    fee: 'الأتعاب',
    riyal: 'ريال سعودي',
    deliverable: 'عرض ملف التسليم',
    opensInNewTab: '(يفتح في نافذة جديدة)',
    cancelRequest: 'إلغاء الطلب',
    cancelConfirm: 'هل تريد إلغاء هذا الطلب؟ لن تتمكن من متابعته بعد الإلغاء.',
    cancelYes: 'نعم، ألغِ الطلب',
    keep: 'تراجع',
    deliverLabel: 'رابط ملف التسليم (اختياري)',
    deliverHint: 'الصق الرابط كاملاً كما يظهر في شريط المتصفح.',
    deliverInvalid: 'أدخل رابطاً كاملاً وصحيحاً.',
    deliverConfirm: 'تأكيد التسليم',
    updated: 'تم تحديث حالة الطلب.',
  },

  errors: {
    disabled: 'الخدمات المهنية غير مفعّلة حالياً.',
    load: 'تعذّر تحميل طلباتك. تحقّق من اتصالك ثم أعد المحاولة.',
    create: 'تعذّر إرسال الطلب. حاول مرة أخرى.',
    invalid: 'تحقّق من الحقول ثم أعد المحاولة.',
    noProvider: 'لم نجد هذا المختص. تحقّق من الاختيار.',
    update: 'تعذّر تحديث الطلب. حاول مرة أخرى.',
    forbidden: 'لا تملك صلاحية تحديث هذا الطلب.',
    notFound: 'لم يعد هذا الطلب متاحاً.',
    session: 'انتهت جلستك. سجّل الدخول مرة أخرى للمتابعة.',
    retry: 'إعادة المحاولة',
  },
};

export default engage;
